const SAFETY_BASE = 'https://www.heidihealth.com';

/**
 * Resolves the Heidi safety page URL for onboarding compliance copy.
 *
 * Always returns the unprefixed global path so the marketing site can redirect
 * to the correct locale/slug based on the visitor's location.
 */
export function getSafetyPageUrl(): string {
  return `${SAFETY_BASE}/safety`;
}
